<script setup lang="ts">
import MenuIcon from "@/components/icons/MenuIcon.vue";
import IconNotificacaoVazio from "@/components/icons/IconNotificacaoVazio.vue";
import FavoritoSelecionado from '@/components/icons/FavIcon.vue'
import FavoritoVazio from '@/components/icons/Fav2Icon.vue'
import ArrowUpLaranja from "@/components/icons/ArrowUpLaranja.vue";
import { useObraStore } from "@/stores/obras";
import { mobileOverlayStore } from '@/stores/mobileOverlay';
import { useSidebarStore } from "@/stores/sidebar";
useObraStore();
useSidebarStore();
</script>

<template>
    <div class="d-flex justify-content-center ">
        <div class="mobile-filter-options-container " :class="classOptions">
            <div v-if="showOptions" class="d-flex top-mobile-background">

            </div>
            <button type="button" class="btn btn-link mobile-button-size" @click="showOptionsMenu">
                <menu-icon />
            </button>
            <div v-if="showOptions">
                <div class="d-flex justify-content-center mt-1">
                    <div class="bd-highlight flex-grow-1 ">
                        <ul class="nav nav-pills nav-flush flex-column mb-3 text-center">
                            <!-- 
                                TODO: #17084
                                Desabilitado temporariamento Task #17084
                                http://redmine.eisolucoesinteligentes.com.br/redmine/issues/17084
                            -->
                            <!-- 
                                <li>
                                    <router-link class="nav-link py-3 rounded-0 mobile-button-size mb-3"
                                        to="/mobile/notificacoes">
                                        <icon-notificacao-vazio />
                                    </router-link>
                                </li>
                                <div class="menu-border-bottom"></div> 
                            -->
                            <li>
                                <a class="nav-link py-3 rounded-0 circle orange mobile-button-size mb-3"
                                    @click.stop="filtrarPorFavoritos">
                                    <FavoritoSelecionado v-if="ObraStore.favoritos" />
                                    <FavoritoVazio v-if="!ObraStore.favoritos" />
                                </a>
                            </li>
                            <div class="menu-border-bottom"></div>
                        </ul>
                        <ul class="nav nav-pills nav-flush flex-column mb-auto text-center">
                            <li>
                                <a href="javascript:void(0)" class="nav-link py-1 rounded-0 mobile-button-size"
                                    @click="filtrarPorStatus('vermelho')">
                                    <i :class="obterIconeSinaleiro('vermelho')"></i>
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" class="nav-link py-1 rounded-0 mobile-button-size"
                                    @click="filtrarPorStatus('amarelo')">
                                    <i :class="obterIconeSinaleiro('amarelo')"></i>
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" class="nav-link py-1 rounded-0 mobile-button-size"
                                    @click="filtrarPorStatus('verde')">
                                    <i :class="obterIconeSinaleiro('verde')"></i>
                                </a>
                            </li>
                        </ul>
                        <ul class="nav nav-pills nav-flush flex-column mb-auto text-center">
                            <li>
                                <router-link :to="{ name: 'logout' }" class="nav-link py-1 rounded-0 mobile-button-size">
                                    <i class="bi bi-power logout-button"></i>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <a href="#" class="btn btn-link mobile-button-hide" @click="showOptionsMenu">
                    <arrow-up-laranja />
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { mapStores } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
    name: "MobileFilterOptions",
    data() {
        return {
            showOptions: false,
            classOptions: '',
            titulosSinaleiroMobile: ['vermelho', 'amarelo', 'verde'],
        };
    },
    watch: {
        'SidebarStore.hideMobileMenu': function () {
            if (this.showOptions) {
                this.showOptionsMenu()
            }
        },
    },
    computed: {
        ...mapStores(useObraStore),
        ...mapStores(mobileOverlayStore),
        ...mapStores(useSidebarStore),
    },
    methods: {
        showOptionsMenu() {
            this.classOptions = !this.showOptions ? 'mobile-filter-options-active' : ''
            this.showOptions = !this.showOptions
            this.$emit('show-options-menu', this.showOptions)
        },
        filtrarPorStatus(status: string) {
            this.ObraStore.filtrarPorStatus(status);
        },
        filtrarPorFavoritos() {
            this.ObraStore.filtrarPorFavoritos(!this.ObraStore.favoritos)
        },
        obterIconeSinaleiro(status: string): string {
            if (this.ObraStore.statusBusca.includes(status)) {
                return 'bi bi-circle-fill circle circle-' + this.obterCorBootstrap(status);
            }

            return 'opacidade bi bi-circle circle circle-' + this.obterCorBootstrap(status);
        },
        obterCorBootstrap(status: string): string {
            switch (status) {
                case 'vermelho':
                    return 'red';
                case 'amarelo':
                    return 'yellow';
                case 'verde':
                    return 'green';
            }
            return 'yellow';
        },
    },
});
</script>

<style scoped> .mobile-filter-options-container {
     min-width: 50px;
     max-width: 56px;
 }

 .mobile-filter-options-active {
     background-color: #ffffff;
 }

 .mobile-button-size {
     height: 50px !important;
     width: 56px !important;
     padding: 3px;
 }

 .mobile-button-size:hover {
     background-color: transparent !important;
 }

 .mobile-button-hide {
     border: none !important;
     padding-bottom: 5px;
 }

 .circle {
     font-size: 26px;
 }

 .opacidade {
     opacity: 0.5;
 }

 .top-mobile-background {
     background-color: #ffffff;
     padding-top: 1.5rem !important;
 }
</style>